import React from 'react'
import {useHistory} from "react-router-dom";
import styles from "../resource-not-found/resource-not-found.module.scss";
import {Button, Col, Row} from "react-bootstrap";

const InternalServerError = () => {
  const history = useHistory();
  const returnToDashboard = () => history.push('/');

  return (
    <div className={styles['panel']}>
      <Row>
        <Col xs={12} lg={6}>
          <Row>
            <Col lg={12}>
              <div className={styles['error-message']}>
                Oh no! The system encountered an error!
              </div>
            </Col>
          </Row>
          <Row>
            <Col lg={12}>
              <Button onClick={()=>returnToDashboard()}>
                RETURN TO DASHBOARD
              </Button>
            </Col>
          </Row>
        </Col>
        <Col xs={12} lg={6}>
          <Row>
            <Col lg={12}>
              <div className={styles['error-code']}>
                500
              </div>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  )
}

export default InternalServerError;
